import Vue from "vue";
import App from "./app.vue";
import router from "./router";
import store from "./store";
import Notifications from "vue-notification";
import QModal from "@/common/plugins/modal";
import VueI18n from "vue-i18n";
import Loading from "vue-loading-overlay";
import VueLazyload from 'vue-lazyload';
import language from "@/common/language";
import LogRocket from 'logrocket';
LogRocket.init(process.env.VUE_APP_LOGROCKET_ID, {
  release: process.env.VUE_APP_VERSION,
});

Vue.use(VueI18n);
Vue.use(Notifications);
Vue.use(QModal);
Vue.use(Loading);

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require('./assets/images/muuq-base/noimage.png'),
  loading: require('./assets/images/muuq-base/noimage.png'),
  attempt: 1
})

Vue.prototype.isLoading = false;

Vue.config.productionTip = false;
const numberFormats = {
  'ja-JP': {
    currency: {
      style: 'currency', currency: 'JPY', useGrouping: true, currencyDisplay: 'symbol'
    },
    decimal: {
      style: 'decimal', minimumSignificantDigits: 3, maximumSignificantDigits: 7
    },
    percent: {
      style: 'percent', useGrouping: false
    }
  }
};
const trans18next = new VueI18n({
  locale: language.getLang(),
  messages: language.getMessages(),
  numberFormats,
});

const vueApp = new Vue({
  router,
  i18n: trans18next,
  store,
  render: (h) => h(App),
}).$mount("#app");

export default vueApp;
